import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Icon } from 'loyal-react'

const BenefitsItem = ({ bannerIndex, name, path, className, items }) => {
  return (
    <div key={bannerIndex} className={`pos-benefits pos-${bannerIndex} ${className}`}>
      {
        items && items.length > 0 ? (
          <div className='row mx-0 mx-sm-auto'>
            {
              items.map((item, index) => (
                <div key={index} className={`col-6 pos-benefits-sub pos-sub-${index} ${item.className}`}>
                  <Link
                    className='bg-white radius border border-color-ui-2 d-flex align-items-center justify-content-center py-2 px-2 pointer'
                    to={item.path}
                    title={item.name}
                  >
                    <div className='txt-center'>
                      <Icon
                        iconName={item.icon}
                        className='d-inline-block color-brand-1 icon-lg'
                      />
                      <p className='txt-title fontSize25 lineHeight29 mt-2'>{item.name}</p>
                      <p className='txt-descr fontSize16 lineHeight19 tt mt-1 mbCardsHome'>
                        {item.description}
                      </p>
                    </div>
                  </Link>
                </div>
              )) }
          </div>
        ) : (
          <div className='box-benefits row align-items-center mx-0'>
            <div className='mx-auto radius bannerHomeNew'>
              <Link
                className=''
                to={path}
                title={name}
              />
            </div>
          </div>
        )}
    </div>
  )
}

BenefitsItem.propTypes = {
  bannerIndex: PropTypes.number,
  name: PropTypes.string,
  path: PropTypes.string,
  items: PropTypes.any,
  className: PropTypes.string
}

export default BenefitsItem



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/BenefitsShowcase/BenefitsItem.js